import Monitoring from '../Monitoring/Monitoring'
import useHomeType from 'hooks/useHomeType'

export const RotaMonitoringScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return <Monitoring />
}
